import React, { useEffect, useState, useRef } from "react";
import classes from "./LoanApproval.module.css";
import HeaderNav from "../../Components/Dahboard Header/HeaderNav/HeaderNav";
import { useLocation, useNavigate } from "react-router-dom";
import searchicon from "../../Assets/searchicon.png";
import Footer from "../../Components/Footer/Footer";
import { Trash2, SquarePen, Eye } from "lucide-react";
import api from "../../Components/API/Api";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import Swal from "sweetalert2";
import ApproveLoanModal from "./ApproveLoan";

const LoanApproval = () => {
  const location = useLocation();
  const navigate = useNavigate();
const [approvalType, setApprovalType] = useState("all");
  const [invoices, setInvoices]     = useState([]);
  const [loading, setLoading]       = useState(true);
  const [selectMetrics, setSelectedMetrics] = useState(null);

  // ── SINGLE source of truth for the modal ──────────────────────────
  const [selectedLoan, setSelectedLoan]       = useState(null);
  const [showApproveModal, setShowApproveModal] = useState(false);
  // ─────────────────────────────────────────────────────────────────

  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState({
    current_page: 1,
    last_page: 1,
    total: 0,
    per_page: 15,
  });

  const pageMap = {
    "/dashboard":    "Dashboard",
    "/transactions": "Transactions",
    "/accounts":     "Accounting",
    "/reports":      "Reports",
    "/banking":      "Banking",
    "/settings":     "Settings",
  };

  /* ── Fetch ───────────────────────────────────────────────────────── */
  const fetchInvoices = async () => {
  setLoading(true);

  try {
    const endpoint =
      approvalType === "all"
        ? "/v1/fetch_loan_applications"
        : "/v1/fetch_additional_loan";

    const res = await api.get(`${endpoint}?page=${page}`);

    const paginatedData = res.data?.data;

    setInvoices(paginatedData?.data || []);

    setPagination({
      current_page: paginatedData?.current_page || 1,
      last_page: paginatedData?.last_page || 1,
      total: paginatedData?.total || 0,
      per_page: paginatedData?.per_page || 15,
    });
  } catch (error) {
    console.error(error);
    setInvoices([]);
  } finally {
    setLoading(false);
  }
};

  useEffect(() => {
  fetchInvoices();
}, [page, approvalType]);

  /* ── Row click → open modal ─────────────────────────────────────── */
  const handleRowClick = (loan) => {
    setSelectedLoan(loan);      // store the row data
    setShowApproveModal(true);  // open the modal
  };

  /* ── Close modal ────────────────────────────────────────────────── */
  const handleCloseModal = () => {
    setShowApproveModal(false);
    setSelectedLoan(null);
  };

  /* ── Status helpers ─────────────────────────────────────────────── */
  const statusClass = (approved) => {
    if (Number(approved) === 1) return classes.greenStatus;
    if (Number(approved) === 2) return classes.redStatus;
    return classes.yellowStatus;
  };

  /* ── Delete / reverse ───────────────────────────────────────────── */
  const handleReversePurchaseInvoice = async (item) => {
    const result = await Swal.fire({
      title: "Reverse Purchase Invoice",
      text: "Are you sure you want to reverse this purchase invoice? This action cannot be undone.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, reverse it!",
    });
    if (!result.isConfirmed) return;

    try {
      const response = await api.post(`/v1/reverse-purchase-invoice`, {
        invoice_id:      item.id,
        invoice_number:  item.invoice_number || item.document_number,
      });
      if (response.status === 200 || response.status === 201) {
        setInvoices((prev) => prev.filter((inv) => inv.id !== item.id));
        Swal.fire({ title: "Success!", text: "Purchase invoice reversed successfully.", icon: "success", confirmButtonColor: "#3085d6" });
      }
    } catch (error) {
      Swal.fire({
        title: "Error!",
        text: error.response?.data?.message?.invoice_number?.[0] || "Error reversing purchase invoice. Please try again.",
        icon: "error",
        confirmButtonColor: "#3085d6",
      });
    }
  };

  /* ── Pagination ─────────────────────────────────────────────────── */
  const handleFirstPage    = () => setPage(1);
  const handlePreviousPage = () => { if (pagination.current_page > 1) setPage((p) => p - 1); };
  const handleNextPage     = () => { if (pagination.current_page < pagination.last_page) setPage((p) => p + 1); };
  const handleLastPage     = () => setPage(pagination.last_page);

  /* ── Render ─────────────────────────────────────────────────────── */
  return (
    <div>
      <HeaderNav activePage={pageMap[location.pathname]} />

      <div className={classes.Container}>
        <header className={classes.Header}>
          <h2 className={classes.Title}>Loan Approvals</h2>
          <h1 className={classes.Titles}>
            Review member loan applications, approve eligible requests, and monitor approval activities.
          </h1>
        </header>

        {/* ── Metric Cards ────────────────────────────────────────── */}
        <div className={classes.entrjj}>
          <div className={classes.allkads}>
            <div className={classes.thrdkad}>
              <div className={classes.kad}>
                <p className={classes.kdptg}>Total Approved Loans</p>
                <p className={classes.kdptg1}>0</p>
                <div className={classes.rvnue}><p className={classes.skaltxt}>This month</p></div>
              </div>
            </div>
            <div className={classes.frtkad}>
              <div className={classes.kad}>
                <p className={classes.kdptg}>Total Amount Approved</p>
                <p className={classes.kdptg2}>0.00</p>
                <div className={classes.rvnue}><p className={classes.skaltxt}>Amounts Approved</p></div>
              </div>
            </div>
            <div className={classes.frstkad}>
              <div className={classes.kad}>
                <p className={classes.kdptg}>Loan Applications</p>
                <p className={classes.kdptg4}>0.00</p>
                <div className={classes.rvnue}><p className={classes.skaltxt}>This month</p></div>
              </div>
            </div>
          </div>
        </div>

        {/* ── Search Bar ──────────────────────────────────────────── */}
        <div className={classes.headerActions}>
          <div className={classes.actionsRight}>
            <div className={classes.inputWrapper}>
              <img src={searchicon} alt="Search" className={classes.inputIconGreen} />
              <input type="text" className={classes.searchBar} placeholder="Search loan applications" />
            </div>
          </div>

          <div className={classes.filterContainer}>
  <button
    className={`${classes.filterButton} ${
      approvalType === "all" ? classes.activeFilter : ""
    }`}
    onClick={() => {
      setApprovalType("all");
      setPage(1);
    }}
  >
    All Approvals
  </button>

  <button
    className={`${classes.filterButton} ${
      approvalType === "additional" ? classes.activeFilter : ""
    }`}
    onClick={() => {
      setApprovalType("additional");
      setPage(1);
    }}
  >
    Additional Approvals
  </button>
</div>
        </div>

        {/* ── Table ───────────────────────────────────────────────── */}
        <div className={classes.invoicecont}>
          <table className={classes.invoiceTable}>
            <thead style={{ whiteSpace: "nowrap" }}>
              <tr>
                <th>S/N</th>
                <th>Member Name</th>
                <th>Loan Product</th>
                <th>Transaction Date</th>
                <th>Principal Amount</th>
                <th>Interest Amount</th>
                <th>Total Amount</th>
                <th>Balance</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                Array(5).fill().map((_, idx) => (
                  <tr key={idx}>
                    {Array(10).fill().map((_, i) => (
                      <td key={i}><Skeleton height={20} style={{ marginBottom: 10 }} /></td>
                    ))}
                  </tr>
                ))
              ) : invoices.length === 0 ? (
                <tr>
                  <td colSpan={10} style={{ textAlign: "center" }}>No loan application found.</td>
                </tr>
              ) : (
                invoices.map((item, index) => (
                  <tr key={item.id}>
                    <td>{(pagination.current_page - 1) * pagination.per_page + index + 1}</td>
                    <td>{item.member?.name}</td>
                    <td>{item.loan?.loan_name}</td>
                    <td>{item.transaction_date}</td>
                    <td style={{ textAlign: "right" }}>
                      {Number(item.principal_amount).toLocaleString("en-NG", { minimumFractionDigits: 2 })}
                    </td>
                    <td style={{ textAlign: "right" }}>
                      {Number(item.interest_amount).toLocaleString("en-NG", { minimumFractionDigits: 2 })}
                    </td>
                    <td style={{ textAlign: "right" }}>
                      {Number(item.total_repayment).toLocaleString("en-NG", { minimumFractionDigits: 2 })}
                    </td>
                    <td style={{ textAlign: "right" }}>
                      {Number(item.balance).toLocaleString("en-NG", { minimumFractionDigits: 2 })}
                    </td>
                    <td className={statusClass(item.approved)}>
                      {Number(item.approved) === 1
                        ? "Approved"
                        : Number(item.approved) === 2
                        ? "Disapproved"
                        : "Pending"}
                    </td>
                    <td className={classes.actions}>
                      {/* ✅ onClick calls handleRowClick with the full row item */}
                      <Eye
                        size={16}
                        className={classes.editIcon}
                        onClick={() => handleRowClick(item)}
                        style={{ cursor: "pointer" }}
                      />
                      <Trash2
                        size={16}
                        className={classes.deleteIcon}
                        onClick={() => handleReversePurchaseInvoice(item)}
                        style={{ cursor: "pointer" }}
                      />
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>

          {/* ── Pagination ────────────────────────────────────────── */}
          <div className={classes.paginationContainer}>
            <div className={classes.paginationControls}>
              <button onClick={handleFirstPage}    disabled={pagination.current_page === 1}>First</button>
              <button onClick={handlePreviousPage} disabled={pagination.current_page === 1}>Previous</button>

              {Array.from({ length: pagination.last_page }, (_, i) => i + 1)
                .slice(
                  Math.max(0, pagination.current_page - 3),
                  Math.max(5, pagination.current_page + 2)
                )
                .map((pageNumber) => (
                  <button
                    key={pageNumber}
                    onClick={() => setPage(pageNumber)}
                    className={pagination.current_page === pageNumber ? classes.active : ""}
                  >
                    {pageNumber}
                  </button>
                ))}

              <button onClick={handleNextPage} disabled={pagination.current_page === pagination.last_page}>Next</button>
              <button onClick={handleLastPage} disabled={pagination.current_page === pagination.last_page}>Last</button>

              <span className={classes.pageText}>
                Displaying{" "}
                {pagination.total === 0 ? 0 : (pagination.current_page - 1) * pagination.per_page + 1}
                {" - "}
                {Math.min(pagination.current_page * pagination.per_page, pagination.total)}
                {" of "}
                {pagination.total}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* ✅ Modal — driven by showApproveModal + selectedLoan */}
     <ApproveLoanModal
    isOpen={showApproveModal}
    onClose={handleCloseModal}
    loanData={selectedLoan}
    approvalType={approvalType}
    onSuccess={fetchInvoices}
/>

      <Footer />
    </div>
  );
};

export default LoanApproval;